export * from './transformation-type.enum';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/enums/index.js
// module id = 144
// module chunks = 3